<h2 mat-dialog-title>Campaign URL</h2>

<mat-dialog-content class="campaign-url-dialog-content">
  <p class="intro">This is your campaign URL to share:</p>
  <div class="url-row">
    <code class="url-text">{{ data.campaignUrl }}</code>
    <button
      mat-icon-button
      color="primary"
      type="button"
      matTooltip="Copy URL"
      aria-label="Copy campaign URL"
      (click)="copyUrl()">
      <mat-icon>content_copy</mat-icon>
    </button>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" type="button" (click)="close()">OK</button>
</mat-dialog-actions>
